import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

const Grid = ({ className, container, element, fluid, ...otherProps }) => {
  const Element = fluid ? 'main' : element;

  return (
    <Element
      className={classnames(
        container && 'container',
        fluid && 'container-fluid',
        className
      )}
      {...otherProps}
    />
  );
};

Grid.defaultProps = {
  element: 'div',
  fluid: false,
  container: false
};

Grid.propTypes = {
  className: PropTypes.string,
  container: PropTypes.bool,
  element: PropTypes.string,
  fluid: PropTypes.bool
};

export default Grid;
